export { default as Img200 } from './processed/200/ManAtArms_AE_ContentImage.jpg';
export { default as Img400 } from './processed/400/ManAtArms_AE_ContentImage.jpg';
export { default as Imgthumb } from './processed/thumb/ManAtArms_AE_ContentImage.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/ManAtArms_AE_ContentImage.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/ManAtArms_AE_ContentImage.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      213,
      101,
      41
    ],
    "_population": 2025,
    "_hsl": [
      0.05813953488372092,
      0.6771653543307087,
      0.4980392156862745
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      202,
      161
    ],
    "_population": 344,
    "_hsl": [
      0.09111111111111109,
      0.6637168141592922,
      0.7784313725490196
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      116,
      60,
      12
    ],
    "_population": 1,
    "_hsl": [
      0.07692307692307693,
      0.8125,
      0.25098039215686274
    ]
  },
  "Muted": {
    "_rgb": [
      134,
      105,
      84
    ],
    "_population": 420,
    "_hsl": [
      0.06999999999999998,
      0.22935779816513763,
      0.4274509803921569
    ]
  },
  "LightMuted": {
    "_rgb": [
      207,
      174,
      151
    ],
    "_population": 916,
    "_hsl": [
      0.06845238095238096,
      0.3684210526315789,
      0.7019607843137254
    ]
  },
  "DarkMuted": {
    "_rgb": [
      75,
      62,
      45
    ],
    "_population": 587,
    "_hsl": [
      0.09444444444444443,
      0.25,
      0.23529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/ManAtArms_AE_ContentImage.js